export class AbortError extends Error {
    constructor(message?: string) {
        super(message);

        try {
            // @ts-ignore
            this.name = "AbortError";
        } catch {
            // ignore
        }
    }

    get name(): string {
        //Not working anymore since the '"useDefineForClassFields": true' in tsconfig
        return "AbortError";
    }
}

export function isAbortError(error: Error): boolean {
    return error.name === "AbortError";
}
